// Configuración del AI Assistant Genesis
export const AI_CONFIG = {
  name: "Genesis",
  icons: {
    brain: "🧠",
    robot: "🤖", 
    star: "✨",
    angel: "👼",
    dove: "🕊️",
    cross: "✝️",
    book: "📖",
    light: "💡",
    heart: "💜",
    sparkles: "🌟"
  },
  colors: {
    purple_pink: "from-purple-500 to-pink-500",
    blue_purple: "from-blue-500 to-purple-600", 
    green_blue: "from-green-500 to-blue-500",
    orange_red: "from-orange-500 to-red-500",
    indigo_purple: "from-indigo-500 to-purple-500"
  }
};

// Configuración actual
export const CURRENT_CONFIG = {
  icon: AI_CONFIG.icons.brain,
  color: AI_CONFIG.colors.purple_pink,
  hoverColor: "hover:from-purple-600 hover:to-pink-600"
};

// Función para cambiar la configuración (futuro: podría conectarse a base de datos)
export const updateConfig = (newIcon, newColor) => {
  CURRENT_CONFIG.icon = AI_CONFIG.icons[newIcon] || AI_CONFIG.icons.brain;
  CURRENT_CONFIG.color = AI_CONFIG.colors[newColor] || AI_CONFIG.colors.purple_pink;
  
  // Actualizar hover color basado en el color principal
  const hoverMap = {
    "from-purple-500 to-pink-500": "hover:from-purple-600 hover:to-pink-600",
    "from-blue-500 to-purple-600": "hover:from-blue-600 hover:to-purple-700",
    "from-green-500 to-blue-500": "hover:from-green-600 hover:to-blue-600",
    "from-orange-500 to-red-500": "hover:from-orange-600 hover:to-red-600",
    "from-indigo-500 to-purple-500": "hover:from-indigo-600 hover:to-purple-600"
  };
  
  CURRENT_CONFIG.hoverColor = hoverMap[CURRENT_CONFIG.color] || "hover:from-purple-600 hover:to-pink-600";
};